// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --accentColor: #008ef4;
  --accentLightColor: rgba(0, 142, 244, 0.1);
  --textOnAcccentColor: white;
  --backgroundColor: #f5f5f5;
  --backgroudSecondaryColor: white;
  --textColor: black;
  --textSecondaryColor: gray;
  --errorColor: red;
  --grayColor: #0000007a;
  --grayLightColor: #0000002b;
  --grayOnAccentColor: #ffffffdb;
  --grayLightOnAccentColor: #ffffff3a;
}

.createTicket_reportProblem__KieI6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: var(--backgroundColor);
  padding-top: 20px;
  color: var(--textColor);
}
.createTicket_reportProblem__KieI6 .createTicket_errorText__xrkVL {
  margin-top: 10px;
}
.createTicket_reportProblem__KieI6 .createTicket_errorText__xrkVL p {
  color: var(--errorColor);
}
.createTicket_reportProblem__KieI6 .createTicket_container__QYoXB {
  width: 100%;
  max-width: 700px;
  margin: 0 10px;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp {
  width: calc(100% - 20px);
  margin: 0 10px;
  background-color: var(--backgroudSecondaryColor);
  padding: 20px;
  border-radius: 10px;
}
@media (max-width: 900px) {
  .createTicket_reportProblem__KieI6 .createTicket_form__gtlhp {
    background-color: transparent;
    padding: 0;
  }
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_dropzone__Jxch7 {
  border: 2px dashed var(--accentColor);
  border-radius: 10px;
  padding: 20px;
  cursor: pointer;
  text-align: center;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_dropzone__Jxch7:hover {
  background-color: var(--accentLightColor);
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_filesContainer__bpRYi {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_filesContainer__bpRYi .createTicket_fileBar__veQNE {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px;
  width: 100%;
  border-radius: 10px;
  background-color: var(--accentLightColor);
  color: var(--accentColor);
  font-weight: 600;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_filesContainer__bpRYi .createTicket_fileBar__veQNE .createTicket_fileName__rucCi {
  font-size: 15px;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_filesContainer__bpRYi .createTicket_fileBar__veQNE .createTicket_buttons__KCDrU {
  display: flex;
  gap: 10px;
  margin-left: auto;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_filesContainer__bpRYi .createTicket_fileBar__veQNE .createTicket_buttons__KCDrU .createTicket_removeBTN__LL78T {
  all: unset;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  color: var(--accentColor);
  transition: 0.3s;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_filesContainer__bpRYi .createTicket_fileBar__veQNE .createTicket_buttons__KCDrU .createTicket_removeBTN__LL78T:hover {
  color: var(--textOnAcccentColor);
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_prioritySelector__I-fvH {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_prioritySelector__I-fvH .createTicket_priorityOption__YCpw8 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: center;
  cursor: pointer;
  padding: 10px;
  border-radius: 10px;
  font-weight: 600;
  transition: 0.3s;
  width: 100%;
  box-sizing: border-box;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_prioritySelector__I-fvH .createTicket_priorityOption__YCpw8:hover {
  background-color: var(--accentLightColor);
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_prioritySelector__I-fvH .createTicket_priorityOption__YCpw8.createTicket_selected__SXz2L {
  background-color: var(--accentColor);
  color: var(--textOnAcccentColor);
}
@media (max-width: 900px) {
  .createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_prioritySelector__I-fvH .createTicket_priorityOption__YCpw8 {
    flex-direction: column;
  }
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_milestoneSelector__07KgG {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  position: relative;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_milestoneSelector__07KgG .createTicket_selectedOption__3BFgY {
  box-sizing: border-box;
  width: 100%;
  z-index: 150;
  border-radius: 10px;
  border: 1px solid var(--textSecondaryColor);
  background-color: var(--backgroundColor);
  padding: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_milestoneSelector__07KgG .createTicket_selectedOption__3BFgY .createTicket_text__-dKL7 .createTicket_description__DTlWE {
  font-size: 15px;
  font-weight: 400;
  color: var(--textSecondaryColor);
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_milestoneSelector__07KgG.createTicket_open__MNham .createTicket_selectedOption__3BFgY {
  border-bottom: none;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_milestoneSelector__07KgG.createTicket_open__MNham .createTicket_openIndicator__Fs-Kj {
  transform: rotate(180deg);
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_milestoneSelector__07KgG.createTicket_open__MNham .createTicket_options__3KBDu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  box-shadow: 5px 5px 10px 5px rgba(0, 0, 0, 0.2);
  z-index: 100;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid var(--textSecondaryColor);
  background-color: var(--backgroundColor);
  border-top: none;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_milestoneSelector__07KgG.createTicket_open__MNham .createTicket_options__3KBDu .createTicket_option__W8Utq {
  cursor: pointer;
  padding: 15px;
  border-top: 1px solid var(--backgroudSecondaryColor);
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_milestoneSelector__07KgG.createTicket_open__MNham .createTicket_options__3KBDu .createTicket_option__W8Utq .createTicket_description__DTlWE {
  font-size: 15px;
  color: var(--textSecondaryColor);
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_milestoneSelector__07KgG.createTicket_open__MNham .createTicket_options__3KBDu .createTicket_option__W8Utq:hover {
  background-color: var(--accentLightColor);
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_inputGroup__tk5fp {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_inputContainer__\\+aj6D {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_inputContainer__\\+aj6D .createTicket_label__2uF\\+K {
  font-size: 15px;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_inputContainer__\\+aj6D .createTicket_input__NchhN {
  all: unset;
  box-sizing: border-box;
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--textSecondaryColor);
  background-color: var(--backgroundColor);
  padding: 15px;
  font-weight: 600;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_inputContainer__\\+aj6D .createTicket_input__NchhN:focus {
  outline: none;
  border: 1px solid var(--accentColor);
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_inputContainer__\\+aj6D .createTicket_input__NchhN:disabled {
  cursor: not-allowed;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_subtitle__gK6vR {
  margin-top: 30px;
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: bold;
  color: var(--accentColor);
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_blockDescription__6reSv {
  font-size: 15px;
  color: var(--textSecondaryColor);
  margin-bottom: 20px;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_submitBTN__\\+-lzC {
  all: unset;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  background-color: var(--accentColor);
  color: var(--textOnAcccentColor);
  padding: 15px;
  border-radius: 10px;
  text-align: center;
  font-weight: 600;
  transition: transform 0.2s ease, opacity 0.3s ease;
  margin-top: 20px;
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_submitBTN__\\+-lzC:hover {
  opacity: 0.8;
  transform: scale(1.02);
}
.createTicket_reportProblem__KieI6 .createTicket_form__gtlhp .createTicket_submitBTN__\\+-lzC:active {
  transform: scale(0.98);
}`, "",{"version":3,"sources":["webpack://./src/styles/vars.scss","webpack://./src/pages/tickets/create/createTicket.module.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,0CAAA;EACA,2BAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;EACA,mCAAA;ACDF;;AAXA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,wCAAA;EACA,iBAAA;EACA,uBAAA;AAcF;AAZE;EACE,gBAAA;AAcJ;AAZI;EACE,wBAAA;AAcN;AAVE;EACE,WAAA;EACA,gBAAA;EACA,cAAA;AAYJ;AATE;EACE,wBAAA;EACA,cAAA;EACA,gDAAA;EACA,aAAA;EACA,mBAAA;AAWJ;AATI;EAPF;IAQI,6BAAA;IACA,UAAA;EAYJ;AACF;AAVI;EACE,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAYN;AAVM;EACE,yCAAA;AAYR;AARI;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AAUN;AARM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,yCAAA;EACA,yBAAA;EACA,gBAAA;AAUR;AARQ;EACE,eAAA;AAUV;AAPQ;EACE,aAAA;EACA,SAAA;EACA,iBAAA;AASV;AAPU;EACE,UAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AASZ;AAPY;EACE,gCAAA;AASd;AADI;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAGN;AADM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AAGR;AADQ;EACE,yCAAA;AAGV;AAAQ;EACE,oCAAA;EACA,gCAAA;AAEV;AACQ;EAvBF;IAwBI,sBAAA;EAER;AACF;AAGI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AADN;AAGM;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,wCAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADR;AAIU;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;AAFZ;AAQQ;EACE,mBAAA;EACA,6BAAA;EACA,4BAAA;AANV;AASQ;EACE,yBAAA;AAPV;AAUQ;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,+CAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2CAAA;EACA,wCAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;AARV;AAUU;EACE,eAAA;EACA,aAAA;EACA,oDAAA;AARZ;AAUY;EACE,eAAA;EACA,gCAAA;AARd;AAWY;EACE,yCAAA;AATd;AAgBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAdN;AAkBI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAhBN;AAkBM;EACE,eAAA;AAhBR;AAoBM;EACE,UAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,2CAAA;EACA,wCAAA;EACA,aAAA;EACA,gBAAA;AAlBR;AAoBQ;EACE,aAAA;EACA,oCAAA;AAlBV;AAqBQ;EACE,mBAAA;AAnBV;AAwBI;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAtBN;AAyBI;EACE,eAAA;EACA,gCAAA;EACA,mBAAA;AAvBN;AA0BI;EACE,UAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,oCAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;EACA,gBAAA;AAxBN;AA0BM;EACE,YAAA;EACA,sBAAA;AAxBR;AA2BM;EACE,sBAAA;AAzBR","sourcesContent":["$mobileBP: 900px;\n\n:root {\n  --accentColor: #008ef4;\n  --accentLightColor: rgba(0, 142, 244, 0.1);\n  --textOnAcccentColor: white;\n  --backgroundColor: #f5f5f5;\n  --backgroudSecondaryColor: white;\n  --textColor: black;\n  --textSecondaryColor: gray;\n  --errorColor: red;\n  --grayColor: #0000007a;\n  --grayLightColor: #0000002b;\n  --grayOnAccentColor: #ffffffdb;\n  --grayLightOnAccentColor: #ffffff3a;\n}\n","@import '../../../styles/vars.scss';\n\n.reportProblem {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  background-color: var(--backgroundColor);\n  padding-top: 20px;\n  color: var(--textColor);\n\n  .errorText {\n    margin-top: 10px;\n\n    p {\n      color: var(--errorColor);\n    }\n  }\n\n  .container {\n    width: 100%;\n    max-width: 700px;\n    margin: 0 10px;\n  }\n\n  .form {\n    width: calc(100% - 20px);\n    margin: 0 10px;\n    background-color: var(--backgroudSecondaryColor);\n    padding: 20px;\n    border-radius: 10px;\n\n    @media(max-width: $mobileBP) {\n      background-color: transparent;\n      padding: 0;\n    }\n\n    .dropzone {\n      border: 2px dashed var(--accentColor);\n      border-radius: 10px;\n      padding: 20px;\n      cursor: pointer;\n      text-align: center;\n      height: 100px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      box-sizing: border-box;\n\n      &:hover {\n        background-color: var(--accentLightColor);\n      }\n    }\n\n    .filesContainer {\n      display: flex;\n      gap: 10px;\n      flex-wrap: wrap;\n      margin-bottom: 20px;\n\n      .fileBar {\n        display: flex;\n        gap: 10px;\n        align-items: center;\n        padding: 10px;\n        width: 100%;\n        border-radius: 10px;\n        background-color: var(--accentLightColor);\n        color: var(--accentColor);\n        font-weight: 600;\n\n        .fileName {\n          font-size: 15px;\n        }\n\n        .buttons {\n          display: flex;\n          gap: 10px;\n          margin-left: auto;\n\n          .removeBTN {\n            all: unset;\n            cursor: pointer;\n            font-size: 15px;\n            font-weight: 600;\n            color: var(--accentColor);\n            transition: 0.3s;\n\n            &:hover {\n              color: var(--textOnAcccentColor);\n            }\n          }\n        }\n\n      }\n    }\n\n    .prioritySelector {\n      display: flex;\n      gap: 20px;\n      margin-top: 20px;\n\n      .priorityOption {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 10px;\n        justify-content: center;\n        cursor: pointer;\n        padding: 10px;\n        border-radius: 10px;\n        font-weight: 600;\n        transition: 0.3s;\n        width: 100%;\n        box-sizing: border-box;\n\n        &:hover {\n          background-color: var(--accentLightColor);\n        }\n\n        &.selected {\n          background-color: var(--accentColor);\n          color: var(--textOnAcccentColor);\n        }\n\n        @media(max-width: $mobileBP) {\n          flex-direction: column;\n        }\n      }\n\n    }\n\n    .milestoneSelector {\n      display: flex;\n      flex-direction: column;\n      margin-top: 20px;\n      position: relative;\n\n      .selectedOption {\n        box-sizing: border-box;\n        width: 100%;\n        z-index: 150;\n        border-radius: 10px;\n        border: 1px solid var(--textSecondaryColor);\n        background-color: var(--backgroundColor);\n        padding: 15px;\n        font-weight: 600;\n        cursor: pointer;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        .text {\n          .description {\n            font-size: 15px;\n            font-weight: 400;\n            color: var(--textSecondaryColor);\n          }\n        }\n      }\n\n      &.open {\n        .selectedOption {\n          border-bottom: none;\n          border-bottom-right-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n\n        .openIndicator {\n          transform: rotate(180deg);\n        }\n\n        .options {\n          position: absolute;\n          top: 100%;\n          left: 0;\n          width: 100%;\n          box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.2);\n          z-index: 100;\n          display: flex;\n          flex-direction: column;\n          border-radius: 10px;\n          border: 1px solid var(--textSecondaryColor);\n          background-color: var(--backgroundColor);\n          border-top: none;\n          border-top-right-radius: 0;\n          border-top-left-radius: 0;\n\n          .option {\n            cursor: pointer;\n            padding: 15px;\n            border-top: 1px solid var(--backgroudSecondaryColor);\n\n            .description {\n              font-size: 15px;\n              color: var(--textSecondaryColor);\n            }\n\n            &:hover {\n              background-color: var(--accentLightColor);\n            }\n          }\n        }\n      }\n    }\n\n    .inputGroup {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n\n    }\n\n    .inputContainer {\n      display: flex;\n      flex-direction: column;\n      gap: 5px;\n\n      .label {\n        font-size: 15px;\n      }\n\n\n      .input {\n        all: unset;\n        box-sizing: border-box;\n        width: 100%;\n        border-radius: 10px;\n        border: 1px solid var(--textSecondaryColor);\n        background-color: var(--backgroundColor);\n        padding: 15px;\n        font-weight: 600;\n\n        &:focus {\n          outline: none;\n          border: 1px solid var(--accentColor);\n        }\n\n        &:disabled {\n          cursor: not-allowed;\n        }\n      }\n    }\n\n    .subtitle {\n      margin-top: 30px;\n      margin-bottom: 5px;\n      font-size: 18px;\n      font-weight: bold;\n      color: var(--accentColor);\n    }\n\n    .blockDescription {\n      font-size: 15px;\n      color: var(--textSecondaryColor);\n      margin-bottom: 20px;\n    }\n\n    .submitBTN {\n      all: unset;\n      cursor: pointer;\n      width: 100%;\n      box-sizing: border-box;\n      background-color: var(--accentColor);\n      color: var(--textOnAcccentColor);\n      padding: 15px;\n      border-radius: 10px;\n      text-align: center;\n      font-weight: 600;\n      transition: transform 0.2s ease, opacity 0.3s ease;\n      margin-top: 20px;\n\n      &:hover {\n        opacity: 0.8;\n        transform: scale(1.02);\n      }\n\n      &:active {\n        transform: scale(0.98);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reportProblem": `createTicket_reportProblem__KieI6`,
	"errorText": `createTicket_errorText__xrkVL`,
	"container": `createTicket_container__QYoXB`,
	"form": `createTicket_form__gtlhp`,
	"dropzone": `createTicket_dropzone__Jxch7`,
	"filesContainer": `createTicket_filesContainer__bpRYi`,
	"fileBar": `createTicket_fileBar__veQNE`,
	"fileName": `createTicket_fileName__rucCi`,
	"buttons": `createTicket_buttons__KCDrU`,
	"removeBTN": `createTicket_removeBTN__LL78T`,
	"prioritySelector": `createTicket_prioritySelector__I-fvH`,
	"priorityOption": `createTicket_priorityOption__YCpw8`,
	"selected": `createTicket_selected__SXz2L`,
	"milestoneSelector": `createTicket_milestoneSelector__07KgG`,
	"selectedOption": `createTicket_selectedOption__3BFgY`,
	"text": `createTicket_text__-dKL7`,
	"description": `createTicket_description__DTlWE`,
	"open": `createTicket_open__MNham`,
	"openIndicator": `createTicket_openIndicator__Fs-Kj`,
	"options": `createTicket_options__3KBDu`,
	"option": `createTicket_option__W8Utq`,
	"inputGroup": `createTicket_inputGroup__tk5fp`,
	"inputContainer": `createTicket_inputContainer__+aj6D`,
	"label": `createTicket_label__2uF+K`,
	"input": `createTicket_input__NchhN`,
	"subtitle": `createTicket_subtitle__gK6vR`,
	"blockDescription": `createTicket_blockDescription__6reSv`,
	"submitBTN": `createTicket_submitBTN__+-lzC`
};
export default ___CSS_LOADER_EXPORT___;
